import { LinearProgress, Stack } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { styled } from '@mui/material/styles';
import * as React from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { AppState, store, useAppSelector } from 'src/store';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import SelectSubartifact from './SelectSubartifact';
import DocManagementService from './service/DocManagementService';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}));

export interface ISubartifactVersions {
  document_id: string;
  isf_document_id: string;
  isf_document_name: string;
  isf_doc_version_number: number;
  isf_doc_type: string;
  isf_doc_subtype: string;
  isf_artifact_number: string;
  isf_artifact_name: string;
  isf_doc_level: string;
  isf_doc_study: string;
  isf_doc_country: string;
  isf_doc_site: string;
  isf_doc_status: string;
}

const VersionControl = ({
  metaData,
  handleCloseVersion,
  resData,
  selectData,
  checked,
  ClearData,
  setUploaded,
  documentValue,
  setStyleUpload,
  setFileUploaded,
  setDisablePHI,
  docViewer,
  editedFmID,
  setOpenVersion,
  setOpenEditDocVersion
}: any) => {
  const [versionNumber, setVersionNumber] = useState(``);
  const docService = new DocManagementService();
  const [openSubArtifact, setOpenSubArtifact] = useState<boolean>(false);
  const [subArtifactVersions, setSubArtifactVersions] = useState<ISubartifactVersions[]>([]);
  const dispatch = useDispatch();
  let isfLvel: any, isfStudy: any, isfArtifactName: any, isfCountry: string, isfSite: string;
  let docName: any;

  if (docViewer) {
    isfLvel = selectData.isf_doc_level;
    isfStudy = selectData.isf_doc_study;
    isfArtifactName = selectData.isf_artifact_name;
    isfCountry = selectData.isf_doc_country;
    isfSite = selectData.isf_doc_site;
    docName = selectData.isf_document_name;
  } else {
    isfLvel = selectData.document_data.isf_doc_level;
    isfStudy = selectData.document_data.isf_doc_study;
    isfArtifactName = selectData.document_data.isf_artifact_name;
    isfCountry = selectData.document_data.isf_doc_country;
    isfSite = selectData.document_data.isf_doc_site;
    docName = selectData.document_data.isf_document_name;
  }

  const user: any = useAppSelector(state => state.user.user);
  const userName = `${user.firstName + ' ' + user.lastName}`;
  const [isProcessing, setProcessing] = useState(false);
  const SearchHierarchyDetail: any = useSelector((state: AppState) => state.searchHierarchyDetails);

  const handleVersionChange = (e: any) => {
    const value = e.target.value;
    setVersionNumber(value);
  };

  const addSubartifact = async (subartifactDocData: any) => {
    const res: any = await docService.createMasterDocument(
      subartifactDocData,
      process.env.REACT_APP_NAME,
      'DocumentUpload',
      metaData.isf_document_name
    );
    if (res.error) {
      store.dispatch(setSnackbarMessage('Error in uploading document.', 'error'));
    } else {
      store.dispatch(setSnackbarMessage('Document is uploaded successfully.', 'success'));
    }
  };

  const getSubArtifactVersionDetails = async (isfLvel: any, isfStudy: any, isfArtifactName: any) => {
    setProcessing(true);
    const res: any = await docService.getSubArtifactVersionDetails(
      isfLvel,
      isfStudy,
      isfCountry,
      isfSite,
      isfArtifactName,
      process.env.REACT_APP_NAME,
      'DocumentDetails',
      docName
    );
    setProcessing(false);
    if (res.data) {
      setSubArtifactVersions(res.data);
      setOpenSubArtifact(true);
    } else if (res.error) {
      store.dispatch(setSnackbarMessage('Error in getting subartifacts version details.', 'error'));
    }
  };

  const handleUpdatedDocument = (Meta: any, Res: any, metaData: any) => {
    if (versionNumber === 'subartifact') {
      const subartifactDocData: any = {
        file_master_id: Res.id,
        document_data: {
          isf_artifact_number: Meta.document_data.isf_artifact_number,
          isf_document_name: metaData.isf_document_name,
          isf_doc_type: Meta.document_data.isf_doc_type,
          isf_doc_subtype: Meta.document_data.isf_doc_subtype,
          isf_doc_viewer_includes_phi: checked,
          isf_doc_viewer_red_certified_copy: metaData.isf_doc_viewer_red_certified_copy
            ? metaData.isf_doc_viewer_red_certified_copy
            : 'N',
          isf_doc_status: 'Uploaded',
          isf_doc_country: Meta.document_data.isf_doc_country,
          isf_doc_study: Meta.document_data.isf_doc_study,
          isf_doc_site: Meta.document_data.isf_doc_site,
          isf_doc_viewer_department: 'None',
          isf_doc_viewer_language: 'English',
          isf_doc_viewer_approval_cycle: 0,
          isf_doc_viewer_product_detail: 'test1',
          isf_doc_viewer_ref_model_version: 'ISF RM v1.0',
          isf_doc_viewer_format: Res.isf_doc_type,
          isf_doc_viewer_inspection_ready: '',
          isf_doc_viewer_ir_issue_type: '',
          isf_doc_level: Meta.document_data.isf_doc_level,
          isf_artifact_name: Meta.document_data.isf_artifact_name,
          isf_doc_version_number: '1.0',
          isf_doc_milestone: Meta.document_data.isf_doc_milestone,
          isf_document_id: 'str',
          isf_doc_viewer_doc_phi_redacted: metaData.isf_doc_viewer_doc_phi_redacted
            ? metaData.isf_doc_viewer_doc_phi_redacted
            : 'N',
          isf_doc_viewer_created_by: userName
        }
      };
      addSubartifact(subartifactDocData);
      handleCloseVersion();
      documentValue(
        SearchHierarchyDetail?.data[0]?.Study,
        SearchHierarchyDetail?.data[0]?.Country,
        SearchHierarchyDetail?.data[0]?.Site
      );
      setStyleUpload('uploadFile');
      setFileUploaded(null);
      setUploaded(false);
      setDisablePHI(false);
      ClearData();
    } else if (versionNumber === 'Major' || versionNumber === 'Minor' || versionNumber === 'Overwrite') {
      getSubArtifactVersionDetails(isfLvel, isfStudy, isfArtifactName);
    }
  };

  return (
    <div className="versionControl-modal">
      <React.Fragment>
        <DialogContent dividers className="quallityControl-modalcontent version-control-modalcontent">
          <h3> Update Artifact </h3>
          <Grid container>
            <Grid md={12}>
              <p>{`${isfArtifactName}`} artifact already exists. How would you like to make updates?</p>
            </Grid>

            <Grid md={12}>
              {isProcessing && <LinearProgress />}
              <FormControl className="radio-section">
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  defaultValue={versionNumber}
                  onChange={handleVersionChange}
                >
                  <FormControlLabel
                    value={`Major`}
                    control={<Radio />}
                    label={`Update as major change (ex. Version 1.0 → 2.0)`}
                  />
                  <FormControlLabel
                    value={`Minor`}
                    control={<Radio />}
                    label={`Update as minor change (ex. Version 1.0 → 1.1)`}
                  />
                  <FormControlLabel value={`Overwrite`} control={<Radio />} label="Overwrite current version" />
                  {!docViewer && (
                    <FormControlLabel value={'subartifact'} control={<Radio />} label="Upload as a new subartifact" />
                  )}
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item md={12} className="button-actions">
              <Grid container spacing={2}>
                <Grid item md={12} display="flex" justifyContent="flex-end">
                  <Stack direction="row" spacing={2}>
                    <Button className="grey-btn" onClick={handleCloseVersion}>
                      Close
                    </Button>
                    <Button
                      onClick={() => handleUpdatedDocument(selectData, resData, metaData)}
                      disabled={!versionNumber}
                    >
                      Save
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </React.Fragment>
      <React.Fragment>
        <PopupComponent maxWidth="sm" open={openSubArtifact}>
          <SelectSubartifact
            setOpenSubArtifact={setOpenSubArtifact}
            versionNumber={versionNumber}
            subArtifactVersions={subArtifactVersions}
            handleCloseVersion={handleCloseVersion}
            resData={resData}
            metaData={metaData}
            checked={checked}
            documentValue={documentValue}
            setStyleUpload={setStyleUpload}
            setUploaded={setUploaded}
            ClearData={ClearData}
            setFileUploadec={setFileUploaded}
            setDisablePHI={setDisablePHI}
            docViewer={docViewer}
            editedFmID={editedFmID}
            setOpenVersion={setOpenVersion}
          />
        </PopupComponent>
      </React.Fragment>
    </div>
  );
};

export default React.memo(VersionControl);
